export namespace ProfilesActions {
    export class FetchProfiles {
        static readonly type = '[PROFILES] Fetch Profiles';
        constructor() {}
    }
}
